import React from 'react'
import type { IconNodeType } from './icons'

export function renderIconNode(node: IconNodeType): React.ReactNode[] {
	return node.map(([element, attrs], i) =>
		React.createElement(element, { key: attrs.key || i, ...attrs }),
	)
}
